import React from 'react';
import NudsImage from '@nubank/nuds-web/components/Image/Image';

import { addCMSQueryParametersToPath, addCMSQueryParametersToSrcSet } from '../../utils/cms/images/addCMSQueryParameters';

// eslint-disable-next-line react/prop-types
const Image = ({ src, srcSet, ...props }) => {
  const srcUpdated = src ? addCMSQueryParametersToPath(src) : src;
  const srcSetUpdated = addCMSQueryParametersToSrcSet(srcSet);

  return (
    <NudsImage
      webp
      src={srcUpdated}
      srcSet={srcSetUpdated}
      {...props}
    />
  );
};

export default Image;
export { default as backgroundImage } from './backgroundImage/backgroundImage';
export { imageShape } from '@nubank/nuds-web/components/Image/Image';
